import {encodeQueryString, encodeSearchOrderString} from './search-order-parser';
import {buildFacetFilterString} from './url/facet-filter-parser';
import {TabType} from './search-types';
import {encodeTab} from './url/tab-type-parse';
import {encodeQueryFields} from './url/query-fields-parse';
import {HibuFacetFilter, HibuFacetGroup} from '../facets/facet.types';

function buildUri(queryParameters: string[]): string {
    const filteredParams = queryParameters.filter(p => p !== '');
    if (filteredParams.length === 0) {
        return '';
    }
    return '?' + filteredParams.join('&');
}

export function buildEncodedUrlPath(
    route: string,
    searchExpression: string,
    sortField: string,
    facets: HibuFacetGroup[],
    selectedFilters: HibuFacetFilter,
    openTab?: TabType,
    showFieldSpecificSearchEnabled: boolean = false,
    queryFields: string[] = [],
    filterPersisted: boolean = true
): string {
    const searchOrderString = encodeSearchOrderString(sortField);
    const queryString = encodeQueryString(searchExpression.trim());
    const facetFilterString: string = buildFacetFilterString(facets, selectedFilters);
    const tabString = encodeTab(openTab);
    const queryFieldsString = encodeQueryFields(showFieldSpecificSearchEnabled, queryFields);
    const rfString = `rf=${String(filterPersisted)}`;
    const routeString = route ? '/' + route : '';
    return routeString + buildUri([queryString, searchOrderString, facetFilterString, tabString, queryFieldsString, rfString]);
}
